






















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetExamResultList } from "@/request/common";

@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];

  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }
  private goResult(item: any) {
    this.$router.push({
      path: "/main/shixun/exam-condition",
      query: {
        id: item.exam_result_id,
      },
    });
  }
  private goReport() {
    this.$router.push({
      path: "/main/shixun/exam-report",
    });
  }

  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("examListFilter", JSON.stringify(this.filters));
    GetExamResultList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }

  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("examListFilter")) {
      this.filters = JSON.parse(localStorage.getItem("examListFilter") as any);
    }
    this.getList();
  }
}
